let _isHeadlessTask = false

export function setIsHeadlessTask(isHeadless: boolean) {
  // If the app is already fully initialized we're not actually a headless task.
  if (isHeadless) {
    _isHeadlessTask = true
  } else {
    _isHeadlessTask = false
  }
}

export function isHeadlessTask() {
  return _isHeadlessTask
}
